var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "contact-us-page" }, [
    _c("div", { staticClass: "contact-us-page__container" }, [
      _c("div", { staticClass: "contact-us-page__primary" }, [
        _vm._m(0),
        _c("section", { staticClass: "contact-us-page__section" }, [
          _vm._m(1),
          _c("div", { staticClass: "contact-us-page__content" }, [
            _c("h3", { staticClass: "contact-us-page__title" }, [
              _vm._v("Email")
            ]),
            _c("ul", { staticClass: "contact-us-page__list" }, [
              _c(
                "li",
                { staticClass: "contact-us-page__item" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "contact-us-page__label",
                      attrs: { for: "support" }
                    },
                    [_vm._v("Support")]
                  ),
                  _c("Hyperlink", {
                    staticClass: "contact-us-page__link",
                    attrs: {
                      href: "mailto:dmssupport@dominiondms.com",
                      labelText: "dmssupport@dominiondms.com"
                    }
                  })
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "contact-us-page__item" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "contact-us-page__label",
                      attrs: { for: "marketing" }
                    },
                    [_vm._v("Marketing")]
                  ),
                  _c("Hyperlink", {
                    staticClass: "contact-us-page__link",
                    attrs: {
                      href: "mailto:dms_marketing@dominiondms.com",
                      labelText: "dms_marketing@dominiondms.com"
                    }
                  })
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "contact-us-page__item" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "contact-us-page__label",
                      attrs: { for: "accounting and payroll" }
                    },
                    [_vm._v("Accounting and Payroll")]
                  ),
                  _c("Hyperlink", {
                    staticClass: "contact-us-page__link",
                    attrs: {
                      href: "mailto:dms_ap@dominiondms.com",
                      labelText: "dms_ap@dominiondms.com"
                    }
                  })
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "contact-us-page__item" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "contact-us-page__label",
                      attrs: { for: "parts and service" }
                    },
                    [_vm._v("Parts and Service")]
                  ),
                  _c("Hyperlink", {
                    staticClass: "contact-us-page__link",
                    attrs: {
                      href: "mailto:dms_ps@dominiondms.com",
                      labelText: "dms_ps@dominiondms.com"
                    }
                  })
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "contact-us-page__item" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "contact-us-page__label",
                      attrs: { for: "sales and fi" }
                    },
                    [_vm._v("Sales and F&I")]
                  ),
                  _c("Hyperlink", {
                    staticClass: "contact-us-page__link",
                    attrs: {
                      href: "mailto:dms_sl@dominiondms.com",
                      labelText: "dms_sl@dominiondms.com"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "contact-us-page__secondary" }, [
        _c("section", { staticClass: "contact-us-page__section" }, [
          _vm._m(2),
          _c(
            "div",
            { staticClass: "contact-us-page__content" },
            [
              _c("h3", { staticClass: "contact-us-page__title" }, [
                _vm._v("Website")
              ]),
              _c("Hyperlink", {
                staticClass: "contact-us-page__link",
                attrs: {
                  href: "https://www.VUEDMS.com/",
                  labelText: "www.VUEDMS.com"
                }
              })
            ],
            1
          )
        ]),
        _c("section", { staticClass: "contact-us-page__section" }, [
          _vm._m(3),
          _c(
            "div",
            { staticClass: "contact-us-page__content" },
            [
              _c("h3", { staticClass: "contact-us-page__title" }, [
                _vm._v("Mailing Address")
              ]),
              _vm._m(4),
              _c("Hyperlink", {
                staticClass: "contact-us-page__link",
                attrs: {
                  href:
                    "https://www.google.com/maps?q=150+Granby+Street,+Norfolk,+VA+23510",
                  labelText: "View on Google Maps"
                }
              })
            ],
            1
          )
        ]),
        _c(
          "section",
          {
            staticClass:
              "contact-us-page__support contact-us-page__section--support"
          },
          [
            _vm._m(5),
            _c(
              "div",
              { staticClass: "contact-us-page__content" },
              [
                _c(
                  "label",
                  {
                    staticClass: "contact-us-page__label",
                    attrs: { for: "remote support" }
                  },
                  [_vm._v("Remote Support")]
                ),
                _c("Hyperlink", {
                  staticClass: "contact-us-page__link",
                  attrs: {
                    href: "https://get.teamviewer.com/dmssupport",
                    labelText: "https://get.teamviewer.com/dmssupport"
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "contact-us-page__section" }, [
      _c(
        "div",
        { staticClass: "contact-us-page__image contact-us-page__image--phone" },
        [_c("i", { staticClass: "icon icon-phone" })]
      ),
      _c("div", { staticClass: "contact-us-page__content" }, [
        _c("h3", { staticClass: "contact-us-page__title" }, [_vm._v("Phone")]),
        _c("span", { staticClass: "contact-us-page__text" }, [
          _vm._v("1-800-227-8187")
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contact-us-page__image" }, [
      _c("i", { staticClass: "icon icon-contact-email" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "contact-us-page__image contact-us-page__image--website" },
      [_c("i", { staticClass: "icon icon-web" })]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contact-us-page__image" }, [
      _c("i", { staticClass: "icon icon-contact-location" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "contact-us-page__text" }, [
      _vm._v("150 Granby Street "),
      _c("br"),
      _vm._v(" Norfolk, VA 23510")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "contact-us-page__image contact-us-page__image--support" },
      [_c("i", { staticClass: "icon icon-remote-support" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }